<template>
  <div class="md-layout">


    <div class="md-layout-item md-size-100">
    <md-card>
      <md-card-content>
        <!-- <h4>Bagian Luar Body Mobil</h4> -->
        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Atap</h5>
            <md-radio v-model="checker.checker_atap" :value="1">Penyot</md-radio>
            <md-radio v-model="checker.checker_atap" :value="2">Lecet</md-radio>
            <md-radio v-model="checker.checker_atap" :value="3">Baret</md-radio>
            <md-radio v-model="checker.checker_atap" :value="4">Dekok</md-radio>
            <md-radio v-model="checker.checker_atap" :value="5">Pecah</md-radio>
            <md-radio v-model="checker.checker_atap" :value="6">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_atap"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_atap_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_atap_remark_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Bemper Depan</h5>
            <md-radio v-model="checker.checker_bemper_depan" :value="1">Penyot</md-radio>
            <md-radio v-model="checker.checker_bemper_depan" :value="2">Lecet</md-radio>
            <md-radio v-model="checker.checker_bemper_depan" :value="3">Baret</md-radio>
            <md-radio v-model="checker.checker_bemper_depan" :value="4">Dekok</md-radio>
            <md-radio v-model="checker.checker_bemper_depan" :value="5">Pecah</md-radio>
            <md-radio v-model="checker.checker_bemper_depan" :value="6">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_bemper_depan"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_bemper_depan_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_bemper_depan_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        
        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Cover Spion Kiri</h5>
            <md-radio v-model="checker.checker_cover_spion_kiri" :value="1">Penyot</md-radio>
            <md-radio v-model="checker.checker_cover_spion_kiri" :value="2">Lecet/Baret</md-radio>
            <md-radio v-model="checker.checker_cover_spion_kiri" :value="3">Dekok</md-radio>
            <md-radio v-model="checker.checker_cover_spion_kiri" :value="4">Pecah</md-radio>
            <md-radio v-model="checker.checker_cover_spion_kiri" :value="5">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_cover_spion_kiri"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_cover_spion_kiri_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_cover_spion_kiri_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Cover Spion Kanan</h5>
            <md-radio v-model="checker.checker_cover_spion_kanan" :value="1">Penyot</md-radio>
            <md-radio v-model="checker.checker_cover_spion_kanan" :value="2">Lecet/Baret</md-radio>
            <md-radio v-model="checker.checker_cover_spion_kanan" :value="3">Dekok</md-radio>
            <md-radio v-model="checker.checker_cover_spion_kanan" :value="4">Pecah</md-radio>
            <md-radio v-model="checker.checker_cover_spion_kanan" :value="5">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_cover_spion_kanan"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_cover_spion_kanan_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_cover_spion_kanan_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Fender Depan Kiri</h5>
            <md-radio v-model="checker.checker_fender_depan_kiri" :value="1">Penyot</md-radio>
            <md-radio v-model="checker.checker_fender_depan_kiri" :value="2">Lecet</md-radio>
            <md-radio v-model="checker.checker_fender_depan_kiri" :value="3">Baret</md-radio>
            <md-radio v-model="checker.checker_fender_depan_kiri" :value="4">Dekok</md-radio>
            <md-radio v-model="checker.checker_fender_depan_kiri" :value="5">Pecah</md-radio>
            <md-radio v-model="checker.checker_fender_depan_kiri" :value="6">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_fender_depan_kiri"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_fender_depan_kiri_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_fender_depan_kiri_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Fender Belakang Kiri</h5>
            <md-radio v-model="checker.checker_fender_belakang_kiri" :value="1">Penyot</md-radio>
            <md-radio v-model="checker.checker_fender_belakang_kiri" :value="2">Lecet</md-radio>
            <md-radio v-model="checker.checker_fender_belakang_kiri" :value="3">Baret</md-radio>
            <md-radio v-model="checker.checker_fender_belakang_kiri" :value="4">Dekok</md-radio>
            <md-radio v-model="checker.checker_fender_belakang_kiri" :value="5">Pecah</md-radio>
            <md-radio v-model="checker.checker_fender_belakang_kiri" :value="6">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_fender_belakang_kiri"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_fender_belakang_kiri_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_fender_belakang_kiri_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Fender Depan Kanan</h5>
            <md-radio v-model="checker.checker_fender_depan_kanan" :value="1">Penyot</md-radio>
            <md-radio v-model="checker.checker_fender_depan_kanan" :value="2">Lecet</md-radio>
            <md-radio v-model="checker.checker_fender_depan_kanan" :value="3">Baret</md-radio>
            <md-radio v-model="checker.checker_fender_depan_kanan" :value="4">Dekok</md-radio>
            <md-radio v-model="checker.checker_fender_depan_kanan" :value="5">Pecah</md-radio>
            <md-radio v-model="checker.checker_fender_depan_kanan" :value="6">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_fender_depan_kanan"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_fender_depan_kanan_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_fender_depan_kanan_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Fender Belakang Kanan</h5>
            <md-radio v-model="checker.checker_fender_belakang_kanan" :value="1">Penyot</md-radio>
            <md-radio v-model="checker.checker_fender_belakang_kanan" :value="2">Lecet</md-radio>
            <md-radio v-model="checker.checker_fender_belakang_kanan" :value="3">Baret</md-radio>
            <md-radio v-model="checker.checker_fender_belakang_kanan" :value="4">Dekok</md-radio>
            <md-radio v-model="checker.checker_fender_belakang_kanan" :value="5">Pecah</md-radio>
            <md-radio v-model="checker.checker_fender_belakang_kanan" :value="6">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_fender_belakang_kanan"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_fender_belakang_kanan_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_fender_belakang_kanan_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Gril Depan</h5>
            <md-radio v-model="checker.checker_gril_depan" :value="1">Penyot</md-radio>
            <md-radio v-model="checker.checker_gril_depan" :value="2">Lecet</md-radio>
            <md-radio v-model="checker.checker_gril_depan" :value="3">Baret</md-radio>
            <md-radio v-model="checker.checker_gril_depan" :value="4">Dekok</md-radio>
            <md-radio v-model="checker.checker_gril_depan" :value="5">Pecah</md-radio>
            <md-radio v-model="checker.checker_gril_depan" :value="6">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_gril_depan"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_gril_depan_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_gril_depan_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Gril Belakang</h5>
            <md-radio v-model="checker.checker_gril_belakang" :value="1">Penyot</md-radio>
            <md-radio v-model="checker.checker_gril_belakang" :value="2">Lecet</md-radio>
            <md-radio v-model="checker.checker_gril_belakang" :value="3">Baret</md-radio>
            <md-radio v-model="checker.checker_gril_belakang" :value="4">Dekok</md-radio>
            <md-radio v-model="checker.checker_gril_belakang" :value="5">Pecah</md-radio>
            <md-radio v-model="checker.checker_gril_belakang" :value="6">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_gril_belakang"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_gril_belakang_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_gril_belakang_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>


        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Kap Mesin</h5>
            <md-radio v-model="checker.checker_kap_mesin" :value="1">Penyot</md-radio>
            <md-radio v-model="checker.checker_kap_mesin" :value="2">Lecet</md-radio>
            <md-radio v-model="checker.checker_kap_mesin" :value="3">Baret</md-radio>
            <md-radio v-model="checker.checker_kap_mesin" :value="4">Dekok</md-radio>
            <md-radio v-model="checker.checker_kap_mesin" :value="5">Pecah</md-radio>
            <md-radio v-model="checker.checker_kap_mesin" :value="6">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_kap_mesin"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_kap_mesin_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_kap_mesin_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Kaca Depan</h5>
            <md-radio v-model="checker.checker_kaca_depan" :value="1">Penyot</md-radio>
            <md-radio v-model="checker.checker_kaca_depan" :value="2">Lecet</md-radio>
            <md-radio v-model="checker.checker_kaca_depan" :value="3">Baret</md-radio>
            <md-radio v-model="checker.checker_kaca_depan" :value="4">Dekok</md-radio>
            <md-radio v-model="checker.checker_kaca_depan" :value="5">Pecah</md-radio>
            <md-radio v-model="checker.checker_kaca_depan" :value="6">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_kaca_depan"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_kaca_depan_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_kaca_depan_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Kaca Belakang</h5>
            <md-radio v-model="checker.checker_kaca_belakang" :value="1">Penyot</md-radio>
            <md-radio v-model="checker.checker_kaca_belakang" :value="2">Lecet</md-radio>
            <md-radio v-model="checker.checker_kaca_belakang" :value="3">Baret</md-radio>
            <md-radio v-model="checker.checker_kaca_belakang" :value="4">Dekok</md-radio>
            <md-radio v-model="checker.checker_kaca_belakang" :value="5">Pecah</md-radio>
            <md-radio v-model="checker.checker_kaca_belakang" :value="6">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_kaca_belakang"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_kaca_belakang_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_kaca_belakang_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Kaca Pintu Depan Kiri</h5>
            <md-radio v-model="checker.checker_kaca_pintu_depan_kiri" :value="1">Penyot</md-radio>
            <md-radio v-model="checker.checker_kaca_pintu_depan_kiri" :value="2">Lecet</md-radio>
            <md-radio v-model="checker.checker_kaca_pintu_depan_kiri" :value="3">Baret</md-radio>
            <md-radio v-model="checker.checker_kaca_pintu_depan_kiri" :value="4">Dekok</md-radio>
            <md-radio v-model="checker.checker_kaca_pintu_depan_kiri" :value="5">Pecah</md-radio>
            <md-radio v-model="checker.checker_kaca_pintu_depan_kiri" :value="6">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_kaca_pintu_depan_kiri"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_kaca_pintu_depan_kiri_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_kaca_pintu_depan_kiri_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Kaca Pintu Depan Kanan</h5>
            <md-radio v-model="checker.checker_kaca_pintu_depan_kanan" :value="1">Penyot</md-radio>
            <md-radio v-model="checker.checker_kaca_pintu_depan_kanan" :value="2">Lecet</md-radio>
            <md-radio v-model="checker.checker_kaca_pintu_depan_kanan" :value="3">Baret</md-radio>
            <md-radio v-model="checker.checker_kaca_pintu_depan_kanan" :value="4">Dekok</md-radio>
            <md-radio v-model="checker.checker_kaca_pintu_depan_kanan" :value="5">Pecah</md-radio>
            <md-radio v-model="checker.checker_kaca_pintu_depan_kanan" :value="6">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_kaca_pintu_depan_kanan"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_kaca_pintu_depan_kanan_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_kaca_pintu_depan_kanan_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Kaca Pintu Belakang Kiri</h5>
            <md-radio v-model="checker.checker_kaca_pintu_belakang_kiri" :value="1">Penyot</md-radio>
            <md-radio v-model="checker.checker_kaca_pintu_belakang_kiri" :value="2">Lecet</md-radio>
            <md-radio v-model="checker.checker_kaca_pintu_belakang_kiri" :value="3">Baret</md-radio>
            <md-radio v-model="checker.checker_kaca_pintu_belakang_kiri" :value="4">Dekok</md-radio>
            <md-radio v-model="checker.checker_kaca_pintu_belakang_kiri" :value="5">Pecah</md-radio>
            <md-radio v-model="checker.checker_kaca_pintu_belakang_kiri" :value="6">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_kaca_pintu_belakang_kiri"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_kaca_pintu_belakang_kiri_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_kaca_pintu_belakang_kiri_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>List Plang Kanan</h5>
            <md-radio v-model="checker.checker_list_plang_kanan" :value="1">Penyot</md-radio>
            <md-radio v-model="checker.checker_list_plang_kanan" :value="2">Lecet</md-radio>
            <md-radio v-model="checker.checker_list_plang_kanan" :value="3">Baret</md-radio>
            <md-radio v-model="checker.checker_list_plang_kanan" :value="4">Dekok</md-radio>
            <md-radio v-model="checker.checker_list_plang_kanan" :value="5">Pecah</md-radio>
            <md-radio v-model="checker.checker_list_plang_kanan" :value="6">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_list_plang_kanan"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_list_plang_kanan_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_list_plang_kanan_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>List Plang Kiri</h5>
            <md-radio v-model="checker.checker_list_plang_kiri" :value="1">Penyot</md-radio>
            <md-radio v-model="checker.checker_list_plang_kiri" :value="2">Lecet</md-radio>
            <md-radio v-model="checker.checker_list_plang_kiri" :value="3">Baret</md-radio>
            <md-radio v-model="checker.checker_list_plang_kiri" :value="4">Dekok</md-radio>
            <md-radio v-model="checker.checker_list_plang_kiri" :value="5">Pecah</md-radio>
            <md-radio v-model="checker.checker_list_plang_kiri" :value="6">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_list_plang_kiri"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_list_plang_kiri_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_list_plang_kiri_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Pintu Depan Kanan</h5>
            <md-radio v-model="checker.checker_pintu_depan_kanan" :value="1">Penyot</md-radio>
            <md-radio v-model="checker.checker_pintu_depan_kanan" :value="2">Lecet</md-radio>
            <md-radio v-model="checker.checker_pintu_depan_kanan" :value="3">Baret</md-radio>
            <md-radio v-model="checker.checker_pintu_depan_kanan" :value="4">Dekok</md-radio>
            <md-radio v-model="checker.checker_pintu_depan_kanan" :value="5">Pecah</md-radio>
            <md-radio v-model="checker.checker_pintu_depan_kanan" :value="6">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_pintu_depan_kanan"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_pintu_depan_kanan_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_pintu_depan_kanan_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Pintu Belakang Kiri</h5>
            <md-radio v-model="checker.checker_pintu_belakang_kiri" :value="1">Penyot</md-radio>
            <md-radio v-model="checker.checker_pintu_belakang_kiri" :value="2">Lecet</md-radio>
            <md-radio v-model="checker.checker_pintu_belakang_kiri" :value="3">Baret</md-radio>
            <md-radio v-model="checker.checker_pintu_belakang_kiri" :value="4">Dekok</md-radio>
            <md-radio v-model="checker.checker_pintu_belakang_kiri" :value="5">Pecah</md-radio>
            <md-radio v-model="checker.checker_pintu_belakang_kiri" :value="6">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_pintu_belakang_kiri"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_pintu_belakang_kiri_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_pintu_belakang_kiri_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Pintu Depan Kiri</h5>
            <md-radio v-model="checker.checker_pintu_depan_kiri" :value="1">Penyot</md-radio>
            <md-radio v-model="checker.checker_pintu_depan_kiri" :value="2">Lecet</md-radio>
            <md-radio v-model="checker.checker_pintu_depan_kiri" :value="3">Baret</md-radio>
            <md-radio v-model="checker.checker_pintu_depan_kiri" :value="4">Dekok</md-radio>
            <md-radio v-model="checker.checker_pintu_depan_kiri" :value="5">Pecah</md-radio>
            <md-radio v-model="checker.checker_pintu_depan_kiri" :value="6">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_pintu_depan_kiri"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_pintu_depan_kiri_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_pintu_depan_kiri_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Pintu Belakang Kanan</h5>
            <md-radio v-model="checker.checker_pintu_belakang_kanan" :value="1">Penyot</md-radio>
            <md-radio v-model="checker.checker_pintu_belakang_kanan" :value="2">Lecet</md-radio>
            <md-radio v-model="checker.checker_pintu_belakang_kanan" :value="3">Baret</md-radio>
            <md-radio v-model="checker.checker_pintu_belakang_kanan" :value="4">Dekok</md-radio>
            <md-radio v-model="checker.checker_pintu_belakang_kanan" :value="5">Pecah</md-radio>
            <md-radio v-model="checker.checker_pintu_belakang_kanan" :value="6">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_pintu_belakang_kanan"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_pintu_belakang_kanan_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_pintu_belakang_kanan_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Pintu Belakang</h5>
            <md-radio v-model="checker.checker_pintu_belakang" :value="1">Penyot</md-radio>
            <md-radio v-model="checker.checker_pintu_belakang" :value="2">Lecet</md-radio>
            <md-radio v-model="checker.checker_pintu_belakang" :value="3">Baret</md-radio>
            <md-radio v-model="checker.checker_pintu_belakang" :value="4">Dekok</md-radio>
            <md-radio v-model="checker.checker_pintu_belakang" :value="5">Pecah</md-radio>
            <md-radio v-model="checker.checker_pintu_belakang" :value="6">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_pintu_belakang"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_pintu_belakang_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_pintu_belakang_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        

        

        

        

        

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Roda Depan Kiri</h5>
            <md-radio v-model="checker.checker_roda_depan_kiri" :value="1">Penyot</md-radio>
            <md-radio v-model="checker.checker_roda_depan_kiri" :value="2">Lecet</md-radio>
            <md-radio v-model="checker.checker_roda_depan_kiri" :value="3">Baret</md-radio>
            <md-radio v-model="checker.checker_roda_depan_kiri" :value="4">Dekok</md-radio>
            <md-radio v-model="checker.checker_roda_depan_kiri" :value="5">Pecah</md-radio>
            <md-radio v-model="checker.checker_roda_depan_kiri" :value="6">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_roda_depan_kiri"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_roda_depan_kiri_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_roda_depan_kiri_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Roda Depan Kanan</h5>
            <md-radio v-model="checker.checker_roda_depan_kanan" :value="1">Penyot</md-radio>
            <md-radio v-model="checker.checker_roda_depan_kanan" :value="2">Lecet</md-radio>
            <md-radio v-model="checker.checker_roda_depan_kanan" :value="3">Baret</md-radio>
            <md-radio v-model="checker.checker_roda_depan_kanan" :value="4">Dekok</md-radio>
            <md-radio v-model="checker.checker_roda_depan_kanan" :value="5">Pecah</md-radio>
            <md-radio v-model="checker.checker_roda_depan_kanan" :value="6">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_roda_depan_kanan"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_roda_depan_kanan_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_roda_depan_kanan_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Roda Belakang Kiri</h5>
            <md-radio v-model="checker.checker_roda_belakang_kiri" :value="1">Penyot</md-radio>
            <md-radio v-model="checker.checker_roda_belakang_kiri" :value="2">Lecet</md-radio>
            <md-radio v-model="checker.checker_roda_belakang_kiri" :value="3">Baret</md-radio>
            <md-radio v-model="checker.checker_roda_belakang_kiri" :value="4">Dekok</md-radio>
            <md-radio v-model="checker.checker_roda_belakang_kiri" :value="5">Pecah</md-radio>
            <md-radio v-model="checker.checker_roda_belakang_kiri" :value="6">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_roda_belakang_kiri"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_roda_belakang_kiri_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_roda_belakang_kiri_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Roda Belakang Kanan</h5>
            <md-radio v-model="checker.checker_roda_belakang_kanan" :value="1">Penyot</md-radio>
            <md-radio v-model="checker.checker_roda_belakang_kanan" :value="2">Lecet</md-radio>
            <md-radio v-model="checker.checker_roda_belakang_kanan" :value="3">Baret</md-radio>
            <md-radio v-model="checker.checker_roda_belakang_kanan" :value="4">Dekok</md-radio>
            <md-radio v-model="checker.checker_roda_belakang_kanan" :value="5">Pecah</md-radio>
            <md-radio v-model="checker.checker_roda_belakang_kanan" :value="6">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_roda_belakang_kanan"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_roda_belakang_kanan_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_roda_belakang_kanan_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Spion Kiri</h5>
            <md-radio v-model="checker.checker_spion_kiri" :value="1">Ada</md-radio>
            <md-radio v-model="checker.checker_spion_kiri" :value="2">Tidak Ada</md-radio>
            <md-radio v-model="checker.checker_spion_kiri" :value="3">Lecet</md-radio>
            <md-radio v-model="checker.checker_spion_kiri" :value="4">Pecah</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_spion_kiri"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_spion_kiri_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_spion_kiri_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Spion Kanan</h5>
            <md-radio v-model="checker.checker_spion_kanan" :value="1">Ada</md-radio>
            <md-radio v-model="checker.checker_spion_kanan" :value="2">Tidak Ada</md-radio>
            <md-radio v-model="checker.checker_spion_kanan" :value="3">Lecet</md-radio>
            <md-radio v-model="checker.checker_spion_kanan" :value="4">Pecah</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_spion_kanan"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_spion_kanan_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_spion_kanan_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        
         <div class="md-layout-item">
          <autoextra :collection="photo" v-slot="{item,last,index}">
            <div  :class="{last: last}">
              <div v-if="item.photo_attach_view  || item.url_photo_file || item.photo_remark ||  last" class="columns">
                <label :id="'labelAccesoriesFlag_'+index" style="font-weight:bold;" class="label">{{last ? 'New ' : ''}}Photo {{!last ? index + 1 : ''}}</label>
                <div class="md-layout md-gutter">

                  <div class="md-layout-item md-size-50 md-small-size-100" style="margin-bottom:10px;">
                  
                  <input v-model="item.id" :readonly="true" type="hidden"/>

                  

                  <div class="md-layout-item md-small-size-100">
                    <label class="md-layout-item md-size-15 md-form-label">Upload File/Photo</label>
                    <md-field class="md-invalid">
                      <md-file 
                      ref="stnk"
                        @change="on_change_attach_photo(item.photo_attach_view,index)"
                        v-model="item.photo_attach_view"
                        accept="image/jpeg,image/png"
                      />
                      <validation-error
                        :errors="apiValidationErrors.photo_attach"
                      />
                    </md-field>
                    <p v-if="item.photo_attach && item.photo_attach.type != 'image/jpeg' && item.photo_attach.type != 'image/png'" class="mb-0" style="text-align:center;">size: {{ (item.photo_attach.size / 1048576).toFixed(2) }}MB</p>
                  </div>
                  <div class="md-layout-item md-small-size-100" style="margin-bottom:10px;">
                    <md-field >
                      <label class="label" >Remark</label>
                      <md-textarea v-model="item.photo_remark" md-counter="150" maxlength="150" :disabled="!item.photo_attach_view && item.photo_attach_view != 0" md-autogrow></md-textarea>
                    </md-field>
                  </div>
                  </div>

                  <div class="md-layout-item md-size-50 md-small-size-100" style="margin-bottom:10px;">

                    <div class="border p-2 mt-3">
                      <template v-if="item.photo_attach">
                        <viewer class="pointer">
                        <img style="width: auto; max-height:400px; display: block; margin:auto;"
                          :src="item.photo_attach.base64"
                          class="img-fluid"
                        />
                        </viewer>
                        <!-- <p class="mb-0">file name: {{ file_attach_accesories.name }}</p> -->
                        <p class="mb-0">size: {{ (item.photo_attach.size / 1048576).toFixed(2) }}MB</p>
                      </template>
                      <template v-if="!item.photo_attach && item.url_photo_file">
                      <!-- <template v-if="!file_attach_accesories && item.url_photo_file"> -->
                        <template>
                          <span style="color:green"
                            >Current Photo:
                          </span>
                          <viewer class="pointer">
                          <img style="width: auto; max-height:400px; display: block; margin:auto;"
                              :src="item.url_photo_file"
                              
                              class="img-fluid"
                            />
                          </viewer>
                        </template>
                      </template>
                    </div>
                  </div>
                 
                  <md-card-actions style="border:none;">
                  <md-button class="md-danger md-dense"  @click="deleteColumn(index)" v-if="item.photo_attach_view || item.photo_attach_view==0 || item.photo_remark || item.url_photo_file">
                    delete
                  </md-button>
                  </md-card-actions>
                </div>            
              </div>
            </div>
            </autoextra>
          </div>
            
        
      </md-card-content>
    </md-card>
    </div>
  </div>
</template>

<script>
import { Modal } from "@/components";
import ListVehicle from "@/pages/Dashboard/Workshop/Checker/Modal/ListVehicle.vue";
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import Swal from 'sweetalert2';
import  Autoextra  from 'vue-autoextra';


  
  export default {
     name: "add-checker",

    props: ["checker"],

    components: {ValidationError,Autoextra },

    mixins: [formMixin],

    data: () => ({
      photo:[],
      
      
    }),


  // created() {
  //         this.getListNota();
  //     },

  
    methods: {
       on_change_attach_photo(event,index) {
        console.log(index)
      var input = event.target;
      if(!input.files[0] || (input.files[0].size / 1048576).toFixed(2) > 3){
          if(input.files[0]){
          this.sizeTobig(input.files[0].size) 
          }
          // this.resetFile('photo_driver')
          // this.photo_attach = null
          // this.photo_attach = null
          console.log(input)
          this.$set(this.photo, index, {
                  id : this.photo[index].id,
                  photo_remark : this.photo[index].photo_remark,
                  photo_attach : null,
                  photo_attach_view : null,
                  url_photo_file : this.photo[index].url_photo_file,
                  photo_remark : this.photo[index].photo_remark
                  
                });

          
          //console.log(this.photo_attach)
          return
        }
      //check apakah data ada
      if (input.files) {
        var reader = new FileReader();
        //read file
        reader.onload = (e) => {
          //set array filedata
          const fileData = {
            name: input.files[0].name,
            size: input.files[0].size,
            lastModified: input.files[0].lastModified,
            lastModifiedDate: input.files[0].lastModifiedDate,
            type: input.files[0].type,
            base64: e.target.result,
          };
          //set var berdasarkan fildedata
          //this.photo_attach = fileData;
             console.log(this.photo[index]);
             if(this.photo[index]){
               this.$set(this.photo, index, {
                  id : this.photo[index].id,
                  photo_attach : fileData,
                   photo_attach_view : fileData.name,
                  url_photo_file : this.photo[index].url_photo_file,
                  photo_remark : this.photo[index].photo_remark
                  
                });
             }
             else{
               this.$set(this.photo, index, {
                  id : null,
                  photo_attach : fileData,
                   photo_attach_view : fileData.name,
                  url_photo_file : null,
                  photo_remark : null
                  
                });
             }
           

        };
        reader.readAsDataURL(input.files[0]);
      }
    },

  sizeTobig(size){
      Swal.fire({
          icon: 'error',
          title: 'File is to big ('+(size / 1048576).toFixed(2)+'MB)',
          text: 'Maximum attachment file size 3MB',
        })
    },
    deleteColumn(index){
        if (index > -1) {
           this.photo.splice(index, 1)
            var filtered = this.photo.filter(function (el) {
              return el != null;
            });
            this.photo = filtered;
        }
        
      },
    getData() {
      this.checker['images_bagian_body'] = this.photo
        this.$emit('data', this.checker)
       
    },

    async getDataParent() {
      // this.photo = this.checker.checker_image_bagian_luar
      this.checker.checker_image_bagian_body.forEach((value, index) => {

        //set data spare part dari data sparepart
        this.$set(this.photo, index, {
                  id : value.id,
                  photo_attach : null,
                   photo_attach_view : null,
                  url_photo_file : value.url_photo_file,
                  photo_remark : value.photo_remark
                  
                });
      });
    },
  }
};
</script>

